import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import { tw } from "@careinfo/tailwind";

const AddProductComponent = loadable(
  () => import("../../components/ServiceInfo/CreateServiceInfo")
);
const AddService = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["inventory-info"],
    navigateURL: "/accounting/service",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.PRODUCT;
    const formData = {
      ...values,
      is_maintain_stock: false,
      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>Add Service</h1>
      </div>
      <AddProductComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </div>
  );
};

export default AddService;
